import { createBrowserRouter } from 'react-router-dom'

type Router = ReturnType<typeof createBrowserRouter>

export let router: Router | undefined = undefined

export function createRouter(r: Router): void {
  router = r
}
